import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { Stats } from "@/components/Stats";
import { Projects } from "@/components/Projects";
import { WhyUs } from "@/components/WhyUs";
import { Partners } from "@/components/Partners";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { WaveDivider, DiagonalDivider } from "@/components/SectionDivider";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Navbar />
      <Hero />
      <Services />
      <Stats />
      <Projects />
      <WaveDivider topColor="#003366" bottomColor="#F5F5F5" />
      <WhyUs />
      <Partners />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </main>
  );
}
